// extracted by mini-css-extract-plugin
export var root = "Masthead-module--root--zyWmV";
export var rootSmall = "Masthead-module--rootSmall--1nVKI";
export var rootBasic = "Masthead-module--rootBasic--3YAJs";
export var imageOverlay = "Masthead-module--imageOverlay--Mtwyi";
export var container = "Masthead-module--container--1a5Uq";